/* ProfessorPrints — show the right total on the theme's "Add to cart - £X" button
   when a Rebuy Buy More Save More tier (#316871) is chosen or Product Add-Ons
   (#316873) are ticked. The basket was always charged correctly; this only fixes
   the label. The theme keeps rewriting its own price span, so we leave it alone,
   hide it while our total applies, and show our own span next to it. */
(function () {
  if (window.__ppAtcLivePrice) return;
  window.__ppAtcLivePrice = true;

  var BMSM = '#rebuy-widget-316871';
  var ADDONS = '#rebuy-widget-316873';

  var css = document.createElement('style');
  css.textContent =
    '.pp-live-price,.pp-live-compare{display:none}' +
    '.pp-live .pp-atc__price,.pp-live .pp-atc__compare{display:none!important}' +
    '.pp-live .pp-live-price{display:inline}' +
    '.pp-live .pp-live-compare{display:inline;margin-left:6px;text-decoration:line-through;opacity:.6;font-size:.85em}';
  document.head.appendChild(css);

  function q(s, r) { return (r || document).querySelector(s); }

  function num(t) {
    if (!t) return null;
    var m = String(t).match(/\d[\d.,]*/);
    if (!m) return null;
    var s = m[0];
    if (/,\d{2}$/.test(s)) s = s.replace(/\./g, '').replace(',', '.');
    else s = s.replace(/,/g, '');
    var v = parseFloat(s);
    return isNaN(v) ? null : v;
  }

  function fmt(n, tpl) {
    var m = String(tpl).match(/\d[\d.,]*/);
    var v = n.toFixed(2);
    if (m && /,\d{2}$/.test(m[0])) v = v.replace('.', ',');
    return m ? String(tpl).replace(m[0], v) : '£' + v;
  }

  function readWidgets() {
    var tierTotal = null, tierCmp = null;
    var active = q(BMSM + ' .rebuy-buy-more-save-more__block--active');
    if (active) {
      var pr = q('.rebuy-buy-more-save-more__block-info-price', active);
      var ca = q('.rebuy-buy-more-save-more__block-info-compare-at-price', active);
      tierTotal = pr ? num(pr.textContent) : null;
      tierCmp = ca ? num(ca.textContent) : null;
    }
    var addons = 0;
    document.querySelectorAll(ADDONS + ' .rebuy-addon__item').forEach(function (it) {
      var cb = q('.rebuy-checkbox', it);
      if (cb && cb.checked) {
        var m = q('.rebuy-money:not(.compare-at)', it);
        var v = m ? num(m.textContent) : null;
        if (v) addons += v;
      }
    });
    return { tierTotal: tierTotal, tierCmp: tierCmp, addons: addons };
  }

  function update() {
    var w = readWidgets();
    var discounted = w.tierTotal !== null && w.tierCmp !== null;
    var changed = discounted || w.addons > 0;

    document.querySelectorAll('.pp-atc__price').forEach(function (p) {
      var holder = p.parentElement;
      var btn = p.closest('button') || holder;
      if (!changed) { btn.classList.remove('pp-live'); return; }

      var base = num(p.textContent);
      if (base === null) return;
      var themeCmp = q('.pp-atc__compare', holder);
      var main = discounted ? w.tierTotal : base;
      var total = main + w.addons;
      var was = discounted ? w.tierCmp + w.addons
        : (themeCmp && num(themeCmp.textContent) ? num(themeCmp.textContent) + w.addons : null);

      var lp = q('.pp-live-price', holder);
      if (!lp) {
        lp = document.createElement('span');
        lp.className = 'pp-live-price';
        p.insertAdjacentElement('afterend', lp);
      }
      var lc = q('.pp-live-compare', holder);
      if (!lc) {
        lc = document.createElement('span');
        lc.className = 'pp-live-compare';
        lp.insertAdjacentElement('afterend', lc);
      }
      var tp = fmt(total, p.textContent);
      var tc = was ? fmt(was, p.textContent) : '';
      if (lp.textContent !== tp) lp.textContent = tp;
      if (lc.textContent !== tc) lc.textContent = tc;
      btn.classList.add('pp-live');
    });
  }

  var t;
  function soon() {
    clearTimeout(t);
    t = setTimeout(update, 50);
  }

  document.addEventListener('click', function () { soon(); setTimeout(update, 400); }, true);
  document.addEventListener('change', function () { soon(); setTimeout(update, 400); }, true);
  // Rebuy renders its widgets after load and re-renders on variant change.
  var mo = new MutationObserver(soon);
  function watch() {
    [BMSM, ADDONS].forEach(function (s) {
      var el = q(s);
      if (el && !el.__ppWatched) {
        el.__ppWatched = true;
        mo.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      }
    });
  }
  setInterval(function () { watch(); update(); }, 1000);
  watch();
  update();
})();
